import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=b301f2ba&scoped=true&"
import script from "./RoleEdit.vue?vue&type=script&lang=js&"
export * from "./RoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=b301f2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b301f2ba",
  null
  
)

export default component.exports